(() => {
  angular
    .module('app.settings')
    .factory('SettingsService', SettingsService);

  SettingsService.$inject = [
    '$q',
    '$window',
    'AccountService',
    'IntegrationsService',
    'CustomSegmentsService',
  ];

  function SettingsService(
    $q,
    $window,
    AccountService,
    IntegrationsService,
    CustomSegmentsService,
  ) {
    var basicSettings = {
      cid: null,
      companyId: null,
      companyName: '',
      originalCompanyName: ''
    };

    // FIXME: remove this
    var originalAdformSettings = {
      active: false,
      username: '',
      password: ''
    };

    var createdCustomSegments = [];
    var deletedCustomSegments = [];
    var originalCreatedCustomSegments = [];

    var accountServicePromise = AccountService.getCurrentAccount();
    accountServicePromise.then((data) => {
      basicSettings.cid = data.cid;
      basicSettings.companyId = data.companyId;
      basicSettings.companyName = basicSettings.originalCompanyName = data.companyName;
    });

    const integrationsServicePromise = IntegrationsService.getIntegrations().$promise;
    integrationsServicePromise.then((data) => {
      originalAdformSettings = { ...data.adform };
    });

    const customSegmentsPromise = CustomSegmentsService.getPaginatedCustomSegments('created', 0, 1000, 'name', true);
    customSegmentsPromise.then((response) => {
      if (!angular.isUndefined(response.data)) {
        createdCustomSegments = angular.copy(response.data.customSegments);
        originalCreatedCustomSegments = angular.copy(response.data.customSegments);
      }
    });

    return {
      customSegmentsPromise,
      accountServicePromise,
      integrationsServicePromise,

      getCID: () => basicSettings.cid,
      getCompanyId: () => basicSettings.companyId,
      getCompanyName: () =>basicSettings.companyName,
      setCompanyName: companyName => basicSettings.companyName = companyName,

      getCreatedCustomSegments: () => createdCustomSegments,

      setCreatedCustomSegments: function (newCreatedCustomSegments) {
        createdCustomSegments = newCreatedCustomSegments;
      },
      addDeletedCustomSegment: function (customSegment) {
        deletedCustomSegments.push(customSegment);
      },

      saveSettings: function () {
        var savePromises = [];
        if (basicSettingsChanged()) {
          savePromises.push(AccountService.updateCurrentAccount(basicSettings));
        }

        if (createdCustomSegmentsChanged()) {
          var newCustomSegments = _.filter(createdCustomSegments, function (customSegment) {
            return angular.isUndefined(customSegment.csid);
          });

          var updatedCustomSegments = _.filter(createdCustomSegments, function (customSegment) {
            if (angular.isUndefined(customSegment.csid)) return false;
            var originalCustomSegment = _.findWhere(originalCreatedCustomSegments, {csid: customSegment.csid});
            return !angular.equals(customSegment, originalCustomSegment);
          });

          if (newCustomSegments.length > 0) {
            savePromises.push(CustomSegmentsService.save(newCustomSegments).$promise);
          }
          if (updatedCustomSegments.length > 0) {
            savePromises.push(CustomSegmentsService.update(updatedCustomSegments).$promise);
          }
          if (deletedCustomSegments.length > 0) {
            savePromises.push(CustomSegmentsService.delete(deletedCustomSegments).$promise);
          }
        }

        return $q.all(savePromises);
      },
      settingsChanged: function () {
        return (basicSettingsChanged() || createdCustomSegmentsChanged());
      },

      setAdformSettings: settings => {
        const adformSettings = { ...settings };
        $q.all(
          IntegrationsService.update({
            adform: adformSettings,
          }).$promise,
        ).then(() => {
          $window.location.reload();
        });
      },

      isV2Enabled: () => !originalAdformSettings.active,
    };

    function basicSettingsChanged() {
      return basicSettings.companyName != basicSettings.originalCompanyName;
    }

    // function integrationSettingsChanged() {
    //   return !angular.equals(adformSettings, originalAdformSettings);
    // }

    function createdCustomSegmentsChanged() {
      //NOTE: difference between _.isEqual and angular.equals is that angular.equals ignore $ variables such as $$hashkey
      return !angular.equals(createdCustomSegments, originalCreatedCustomSegments);
    }
  }
})();
